import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import styled from "styled-components";
import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import { DefaultBox } from "../UplusMatchingInfo/UplusCodeDownloadModal";
import dayjs from "dayjs";
import Blank from "../../../DefaultStyles/Blank";

interface YoutubeLogModalProps extends DefaultModalCommonProps {
  partyid: number;
}

export default function YoutubeLogModal({
  closeEvent,
  confirmEvent,
  partyid,
}: YoutubeLogModalProps) {
  const auth = useRecoilValue(authType);

  const { response, loading, error } = useApi({
    method: "get",
    url: auth?.uplus && partyid > 0 ? `proxyparty/log/${partyid}` : undefined,
  });

  useEffect(() => {
    if (response?.status === 200 && response?.data?.length === 0) {
      toast.error("로그를 확인할 수 없습니다.");
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "로그 확인에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
      
        modalTitle="로그 확인"
        cancelBtn={<></>}
        closeEvent={() => closeEvent()}
        confirmEvent={() => closeEvent()}
        isLargeModal={true}
        // isMediumModal={true}
        // leftBottomName={
        //   response?.data[response?.data?.length - 1]?.updater
        // }
        // leftBottomTime={
        //   response?.data[response?.data?.length - 1]?.date
        // }
        
      >
        {response?.data?.length > 0 && (
          <Flex gapSize={12}>
            <Column style={{width: "50%"}}>
              <ModalLabel>내용</ModalLabel>
            </Column>

            <ModalLabel style={{width: "30%"}}>로그 시간</ModalLabel>
            <ModalLabel style={{width: "20%"}}>작업자</ModalLabel>
          </Flex>
        )}

        {response?.data?.map(
          (l: {
            id: string;
            comment: string;
            updater: string;
            date: string;
          }) => (
            <Row key={l?.id}>
              <Flex gapSize={12}>
                <Column  style={{width: "50%"}}>
                  <DefaultBox>{l?.comment}</DefaultBox>
                </Column>

                <DefaultBox style={{ width: "30%" }}>
                  {dayjs(l?.date).format("YYYY-MM-DD HH:mm")}
                </DefaultBox>
                <DefaultBox style={{ width: "20%" }}>{l?.updater}</DefaultBox>
              </Flex>
            </Row>
          )
        )}

        <Blank marginHeight={20} blankHeight={20} />
      </DefaultModalLayout>

      {loading && <Loader />}
    </>
  );
}

const Column = styled.div`
  width: 350px;
`;

const Row = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
